// src/pages/CreatePage.jsx
import React, { useState } from 'react';

const CreatePage = () => {
  const [tokenName, setTokenName] = useState('');
  const [ticker, setTicker] = useState('');
  const [imageUrl, setImageUrl] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({ tokenName, ticker, imageUrl });
    // In future: Send this data to backend for validation and storage
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Create a New MemeCoin</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <label style={styles.label}>Token Name:</label>
        <input style={styles.input} value={tokenName} onChange={(e) => setTokenName(e.target.value)} />

        <label style={styles.label}>Ticker (e.g. $RARE):</label>
        <input style={styles.input} value={ticker} onChange={(e) => setTicker(e.target.value)} />

        <label style={styles.label}>Image URL:</label>
        <input style={styles.input} value={imageUrl} onChange={(e) => setImageUrl(e.target.value)} />

        <button type="submit" style={styles.button}>Submit</button>
      </form>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '500px',
    margin: '0 auto',
    padding: '2rem',
    fontFamily: 'VT323',
    color: '#f0f0f0',
  },
  heading: {
    fontSize: '2rem',
    textAlign: 'center',
    color: '#FAFF00',
    marginBottom: '2rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  label: {
    fontSize: '1.2rem',
  },
  input: {
    padding: '0.5rem',
    fontSize: '1.1rem',
    borderRadius: '4px',
    border: '1px solid #888',
    backgroundColor: '#1e1e1e',
    color: '#f0f0f0',
  },
  button: {
    marginTop: '1rem',
    padding: '0.75rem',
    fontSize: '1.2rem',
    backgroundColor: '#6e2fbd',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
};

export default CreatePage;
